export const NAV = {
  logo: "nav-logo",
  linkCollections: "nav-link-collections",
  linkAtelier: "nav-link-atelier",
  linkServices: "nav-link-services",
  linkBuyGold: "nav-link-buy-gold",
  linkJournal: "nav-link-journal",
  linkContact: "nav-link-contact",
  ctaBook: "nav-cta-book",
  menuToggle: "nav-menu-toggle",
};

export const HERO = {
  section: "hero-section",
  headline: "hero-headline",
  ctaExplore: "hero-cta-explore",
  ctaAtelier: "hero-cta-atelier",
  scrollHint: "hero-scroll-hint",
};

export const PRODUCTS = {
  section: "products-section",
  card: (slug) => `product-card-${slug}`,
};

export const SERVICES = {
  section: "services-section",
  item: (slug) => `service-item-${slug}`,
};

export const MANIFESTO = {
  section: "manifesto-section",
};

export const TESTIMONIALS = {
  section: "testimonials-section",
  prev: "testimonial-prev",
  next: "testimonial-next",
};

export const INSTAGRAM = {
  section: "instagram-section",
  item: (i) => `instagram-tile-${i}`,
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  phone: "contact-input-phone",
  service: "contact-input-service",
  message: "contact-input-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const FOOTER = {
  section: "footer-section",
  newsletterInput: "footer-newsletter-input",
  newsletterSubmit: "footer-newsletter-submit",
};
